<div class="w-full bg-white text-black p-2">
  <!-- 明細編輯開始 -->
  <div #head class="w-full">
    <app-modal-header
      #modal_header
      class="w-full"
      [isDialog]="isDialog"
      [title]="title"
      [state]="state"
      (onOkClick)="doOk($event)"
      (onEditAndSaveClick)="doEditAndSave($event)"
      (onCancelClick)="doCancel($event)"
    >
    </app-modal-header>
  </div>

  <div class="jk-content">
    <div>
      <div>
        <section>
          <div class="divider divider-start">內容</div>
          <div class="w-full">
            @if (item.WL012 === "M") {
              <app-milkdown-markdown-editor
                class="w-full block"
                [label]="'md內文'"
                [markdown]="markdown()"
                (markdownChange)="editMarkdown($event)"
                [darkMode]="false"
                [path]="getImagePath(item)"
                [host]="srv.host"
              ></app-milkdown-markdown-editor>
            }
            @if (item.WL012 === "T") {
              <app-jktextarea
                class="w-full block"
                label="內文"
                [displayLabel]="true"
                [(value)]="item.WL004"
                height="100px"
                [readOnly]="true"
              >
              </app-jktextarea>
            }
            @if (item.WL012 === "H") {
              <app-jk-rich-editor
                class="w-full block"
                [minHeight]="'200px'"
                label="html內文"
                #WL016Com
                id="WL016"
                [(value)]="item.WL016"
                placeholder="htm內文"
                [readonly]="isBrowse"
                [path]="getImagePath(item)"
                [host]="srv.host"
              >
              </app-jk-rich-editor>
            }
          </div>
          <div class="divider divider-start">記事資訊</div>
          <div class="flex items-center gap-3 w-full">
            <app-jkstarmark
              class="w-6 shrink-0 cursor-pointer"
              [isUpdate]="false"
              (click)="srv.toggleStar(item)"
              [value]="item.WL008"
            >
            </app-jkstarmark>
            <app-jkedit
              label="主旨"
              class="flex-1 min-w-0"
              #WL007Com
              id="WL007"
              [(value)]="item.WL007"
              placeholder="主旨"
              [readonly]="isBrowse"
            >
            </app-jkedit>
            <div class="w-36 shrink-0">
              <app-jkcombobox
                class="jk-combobox-border w-full"
                [styleDisplay]="'flex'"
                labelMode="floating"
                label="格式"
                valueExpr="id"
                displayExpr="idName"
                [(value)]="item.WL012"
                [required]="false"
                [showClearButton]="true"
                [required]="true"
                [items]="srv.MtrWl012List"
              >
              </app-jkcombobox>
            </div>
          </div>
          <div class="ai-section-header my-2"><mat-divider></mat-divider></div>
          <div class="flex flex-wrap items-center gap-4">
            <div class="w-72">
              <app-jkcombobox
                label="大分類"
                #WL014Com
                id="WL014"
                [(value)]="item.WL014"
                [items]="srv.MtrWd015List"
                [readonly]="isBrowse"
              >
              </app-jkcombobox>
            </div>
            <div class="w-32">
              <app-jkcheckboxYN
                label="已歸檔"
                #WL011Com
                id="WL011"
                [(valueYN)]="item.WL011"
                [readonly]="isBrowse"
              >
              </app-jkcheckboxYN>
            </div>
            <div class="w-52">
              <app-jkdatefield
                label="日期"
                [type]="'date'"
                [(value)]="item.WL005"
              ></app-jkdatefield>
            </div>
          </div>
        </section>

        <section>
          <div class="divider divider-start">分類與排序</div>
          <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
            <div>
              <app-jkdatefield
                label="Date"
                #WL006Com
                id="WL006"
                [(date)]="item.WL006"
                placeholder="Date"
                [readonly]="isBrowse"
              >
              </app-jkdatefield>
            </div>
            <div>
              <app-jknumberedit
                label="排序"
                dataType="number"
                [(value)]="item.WL003"
              ></app-jknumberedit>
            </div>
            <div>
              <app-jkedit
                [(value)]="item.WL002"
                labelMode="floating"
                label="序號"
                [required]="true"
              >
              </app-jkedit>
            </div>
            <div>
              <app-jkbtnedit
                [label]="'股票/商品代號'"
                [maintable]="'STKMA'"
                [item]="'W01'"
                [(value)]="item.WL010"
                [valueExpr]="'MA001'"
                [displayExpr]="'MA002'"
              >
              </app-jkbtnedit>
            </div>
          </div>
        </section>

        <section>
          <div class="divider divider-start">系統資訊</div>
          <div class="grid grid-cols-1 gap-3 md:grid-cols-3">
            <div>
              <app-jkedit
                [(value)]="item.WL001"
                labelMode="floating"
                label="單號"
              ></app-jkedit>
            </div>
            <div>
              <app-jkedit
                [(value)]="item.CREATE_DATE"
                labelMode="floating"
                label="建立日期"
                [showClearButton]="true"
              >
              </app-jkedit>
            </div>
            <div>
              <app-jkedit
                [(value)]="item.WL009"
                labelMode="floating"
                label="來源單號"
              ></app-jkedit>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
